<template>
  <b-modal :title="helper.trans('labels.show_request_log')"
           dialog-class="modal-xxl"
           :modelValue="modal"
           footer-class="d-flex justify-content-end"
           @update:modelValue="modal = $event">
    <template #default>
      <LoaderWrapper ref="requestModalLoader">
        <div class="overflow-auto">
          <table class="table table-striped table-sm">
            <thead>
            <tr>
              <th class="text-capitalize-first">{{ $t('labels.id') }}</th>
              <th class="text-capitalize-first">{{ $t('labels.request') }}</th>
              <th class="text-capitalize-first">{{ $t('labels.response') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in logs.items" :key="item.id">
              <td>
                <div class="d-flex flex-column mt-1 mb-1">
                    <span>
                      <span v-b-tooltip.hover :title="item.invoiceId">{{ item.invoiceId.substring(0, 8) }}...</span> <copy-button :value="item.invoiceId"></copy-button>
                    </span>
                </div>
                <div>
                  <small class="text-secondary">{{ dateHelper.format(item.requestAt, 'YYYY-MM-DD') }}</small>
                </div>
                <div>
                  <small class="text-secondary">{{ dateHelper.format(item.requestAt, 'HH:mm:ss') }}</small>
                </div>
                <div>
                  <small class="text-secondary">{{ dateHelper.format(item.responseAt, 'HH:mm:ss') }}</small>
                </div>
              </td>
              <td class="align-top" style="max-width: 500px">
                  <pre><code style="    white-space: pre-line;">
                      {{item.requestMethod}}

                      BODY
                      {{item.request}}
                    </code></pre>
              </td>
              <td class="align-top" style="max-width: 500px">
                  <pre><code style="white-space: pre-line;">
                    CODE: {{item.responseCode}}

                    BODY
                    {{ item.response }}
                    </code></pre>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </LoaderWrapper>
    </template>
    <template #footer>
      <button type="button" @click.prevent="modal = false" class="btn btn-outline-dark btn-sm text-capitalize-first">
        {{ helper.trans('button.close')  }}
      </button>
    </template>
  </b-modal>
</template>

<script lang="ts">

import {computed, defineComponent, ref} from 'vue'
import {reactive, toRefs} from "@vue/reactivity";
import {BModal} from "bootstrap-vue-3";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {$t, helper} from "@/service/CommonHelper";
import {api} from "@/service/APIClient";
import {dateHelper} from "@/service/DateHelper";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import CopyButton from "@/components/CopyButton.vue";
import {numberFormatter} from "@/service/NumberFormatter";

export default defineComponent({
  methods: {$t},
  components: {
    CopyButton,
    BModal,
    LoaderWrapper
  },
  setup() {
    const requestModalLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      modal: false,
      logs: {
        limit: 20,
        offset: 0,
        items: [],
        totalCount: 0
      } as PaginatedResponseDTO<any>
    });

    const show = async (invoiceId: string) => {
      state.logs = {
        limit: 20,
        offset: 0,
        items: [],
        totalCount: 0
      } as PaginatedResponseDTO<any>
      state.modal = true;
      requestModalLoader.value?.show();

      try {
        state.logs = await api.merchantRequestLogs(invoiceId, state.logs);
      } finally {
        requestModalLoader.value?.hide();
      }
    }

    return {
      ...toRefs(state),
      show,
      numberFormatter,
      dateHelper,
      requestModalLoader,
      helper,
    }
  }
})
</script>
